import { ReactComponent as Icon } from "../assets/credit1.svg";

function CreditIcon({ size = 25, color = "currentColor", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" className={className}>
      <circle
        cx="10"
        cy="10"
        r="9.2"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
      />
      <Icon x="1.9" y="2.5" width="15.5" height="15.5" fill={color} />
    </svg>
  );
}

export default CreditIcon;